export default "__VITE_ASSET__YCICNKSg__"